import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { Notificar } from "../../../Comunes/Notificador";
import { __ConvertirABase64 } from "../../../../Utils/Funciones";
import servicioCambiosCic from "../../../../servicios/servicioCambiosCic";

function AgregarArchivoModal({ actualizarArchivos }) {
  const valoresIniciales = {
    archivo: "",
    nombreArchivo: "",
    tipoComplemento: { codigo: "0", descripcion: "" },
    descripcion: "",
  };
  const [show, setShow] = useState(false);
  const [archivo, setArchivo] = useState(valoresIniciales);
  const [datosArchivosPermitidos, setDatosArchivosPermitidos] = useState({});
  const [pesoArchivo, setPesoArchivo] = useState(0);

  useEffect(() => {
    async function obtenerDatosArchivosPermitidos() {
      setDatosArchivosPermitidos(
        await servicioCambiosCic.obtenerDatosArchivosPermitidos()
      );
    }

    obtenerDatosArchivosPermitidos();
  }, []);

  const handleClose = () => {
    setArchivo(valoresIniciales);
    setShow(false);
  };

  const handleShow = () => setShow(true);

  async function handleFileChange(e) {
    const file = e.target.files[0];
    setPesoArchivo(e.target.files[0].size);
    const archivoBase64 = (await __ConvertirABase64(file)).split(",")[1];

    setArchivo({
      ...archivo,
      archivo: archivoBase64,
      nombreArchivo: file.name,
    });
  }

  function handleTipoComplemetoChange(e, descripcion) {
    setArchivo({
      ...archivo,
      tipoComplemento: {
        codigo: e.target.value,
        descripcion: descripcion,
      },
    });
  }

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!datosValidos()) {
      return;
    }

    actualizarArchivos(archivo);
    handleClose();
  };

  function datosValidos() {
    if (!archivo.archivo) {
      Notificar("error", "Debe seleccionar un archivo.");
      return false;
    }

    if (archivo.tipoComplemento.codigo === "0") {
      Notificar("error", "Debe seleccionar el tipo de complemento.");
      return false;
    }

    if (!archivo.descripcion.trim()) {
      Notificar("error", "Debe agregar la descripción del archivo.");
      return false;
    }
    if (!validarFormatoArchivos(archivo)) {
      Notificar(
        "error",
        `Solamente se permiten archivos con formato ${datosArchivosPermitidos.extensionesPermitidas}`
      );
      return false;
    }
    if (!validarPesoArchivos()) {
      Notificar(
        "error",
        `El archivo no debe exceder de ${datosArchivosPermitidos.pesoMaximoEnMegas} MB.`
      );
      return false;
    }

    return true;
  }

  function validarFormatoArchivos(archivo) {
    let extension =
      archivo.nombreArchivo.split(".")[
        archivo.nombreArchivo.split(".").length - 1
      ];
    if (datosArchivosPermitidos.extensionesPermitidas.toLowerCase().includes(extension.toLowerCase()) && extension !== "doc") {
      return true;
    }
    return false;
  }

  function validarPesoArchivos() {
    let PesoEnMegas = datosArchivosPermitidos.pesoMaximoEnMegas * 1024 * 1024; // Kb
    if (PesoEnMegas >= pesoArchivo) {
      return true;
    }
    return false;
  }

  return (
    <>
      <button
        className="btn btn-primary btn-sm btn-icon-split mb-3"
        onClick={handleShow}
      >
        <span className="icon text-white-50">
          <i className="fas fa-plus-circle"></i>
        </span>
        <span className="text">Agregar Archivo</span>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Agregar Archivo</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <div className="form-group">
              <label htmlFor="archivo">Archivo</label>
              <div className="custom-file">
                <input
                  type="file"
                  className="custom-file-input"
                  id="archivo"
                  onChange={handleFileChange}
                />
                <label
                  className="custom-file-label"
                  htmlFor="archivo"
                  data-browse="Adjuntar"
                >
                  {archivo.nombreArchivo || "Seleccionar Archivo"}
                </label>
                <small className="form-text text-muted">
                  El tamaño máximo permitido es de{" "}
                  <strong>{datosArchivosPermitidos.pesoMaximoEnMegas}MB</strong>
                  <br />
                  Las extensiones permitidas son{" "}
                  <strong>
                    {datosArchivosPermitidos.extensionesPermitidas}
                  </strong>
                </small>
              </div>
            </div>

            <div className="form-group">
              <label>Tipo Complemento</label>
              <div>
                <div className="custom-control custom-radio custom-control-inline">
                  <input
                    id="tipoComplementoJustificacion"
                    className="custom-control-input"
                    type="radio"
                    value="1"
                    checked={archivo.tipoComplemento.codigo === "1"}
                    onChange={(e) =>
                      handleTipoComplemetoChange(e, "Justificación")
                    }
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="tipoComplementoJustificacion"
                  >
                    Justificación
                  </label>
                </div>
                <div className="custom-control custom-radio custom-control-inline">
                  <input
                    id="tipoComplementoAccionCorrectiva"
                    className="custom-control-input"
                    type="radio"
                    value="2"
                    checked={archivo.tipoComplemento.codigo === "2"}
                    onChange={(e) =>
                      handleTipoComplemetoChange(e, "Acción Correctiva")
                    }
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="tipoComplementoAccionCorrectiva"
                  >
                    Acción Correctiva
                  </label>
                </div>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="descripcionArchivo">Descripción</label>
              <textarea
                className="form-control"
                name="descripcionArchivo"
                id="descripcionArchivo"
                maxLength="500"
                value={archivo.descripcion}
                onChange={(e) =>
                  setArchivo({ ...archivo, descripcion: e.target.value })
                }
              ></textarea>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>
            <Button variant="primary" type="submit">
              Confirmar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}

export default AgregarArchivoModal;
